import {Constructor} from "../../../../global/constructor";
import {
  ICertificateElementContainer,
  ISortableCertificateElement,
} from "~/interfaces/contentManagementInterfaces";
import TrackedModel from "~/models/tracked/trackedModel";
import {DynamicListFormatType} from "~/enums/dynamicListFormatType";
import {FontType} from "~/enums/fontType";
import {DynamicListBulletStyle, DynamicListBulletStyleToString} from "~/enums/dynamicListBulletStyle";
import Certificate from "../certificate";

export default function DynamicListElement<TBase extends Constructor,
  TCertificateElement extends ISortableCertificateElement &
    TrackedModel,
  TContainer extends TrackedModel &
    ICertificateElementContainer<TCertificateElement> &
    TCertificateElement>(Base: TBase) {
  return class extends Base {
    dynamic_list_client_id: string;
    list_format: DynamicListFormatType;
    line_spacing: number ;
    list_item_spacing: number;
    font: FontType;
    width: number;
    height: number;
    previewText: string[] = [
      "Lorem ipsum dolor sit amet",
      "Consectetur adipiscing elit",
      "Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat",
      "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur"
    ]
    viewer: object;
    editor: object;
    _renderWidth: number;
    _renderHeight: number;
    fill: string;
    font_size: number;
    except = ["viewer", "previewText", "_renderWidth", "_renderHeight", 'editor', ]
    bullet_style: DynamicListBulletStyle;
    certificate: Certificate
    sub_input_client_id: string

    get renderWidth(): number {
      return  this.width;
    }

    get renderHeight(): number {
      return this.height;
    }

    set html(html) {
      //  Do nothing, html is calculated not set, but this is here cause of the froala element
    }

    get html(): string {
      return this.buildListHtml(this.previewText)
    }
    liveDataHTML(repeatableIndex: number){
      const listText = this.certificate.getMappedDataValue(this.dynamic_list_client_id, repeatableIndex, this.sub_input_client_id)
      return this.buildListHtml(listText)
    }


    buildListHtml(listText: Array<string>): string{
      let HTML = `<${this.HTMLTag} style='${this.htmlStyles()}'>`
      if (this.list_format === DynamicListFormatType.CommaSeparatedValues) {
        HTML += listText.join(", ");
      } else {
        HTML += listText.map(text => `<li style='margin: 0 0 ${this.list_item_spacing*this.font_size}px 0;'>${text}</li>`).join("");
      }
      HTML += `</${this.HTMLTag}>`
      return HTML;
    }

    get HTMLTag(): string {
      switch(this.list_format) {
        case DynamicListFormatType.CommaSeparatedValues:
          return "p";
        case DynamicListFormatType.PlainList:
          return "ul";
        case DynamicListFormatType.OrderedList:
          return "ol";
        case DynamicListFormatType.BulletList:
          return "ul";
      }
    }

    htmlStyles(): string {
      const styles = [];
      styles.push(`line-height: ${this.line_spacing}`);
      styles.push(`font-size: ${this.font_size}px`);
      styles.push(`background-color: ${this.fill}`);
      if (this.list_format === DynamicListFormatType.PlainList) {
        styles.push(`list-style-type: none`);
      }
      if (this.list_format === DynamicListFormatType.BulletList) {
        styles.push(`list-style-type: ${DynamicListBulletStyleToString[this.bullet_style].toLowerCase()}`);
      }
      return styles.join('; ') + ";";
    }

    get isConfigured(): boolean {
      return !!this.dynamic_list_client_id;
    }
  }
}